import { gtmFormEvent } from '@klv/shared/utils/google-tag-manager';
import { windowIsDefined } from '@klv/shared/utils/functions';
import handleErrors from '../shared/handle-errors';
import handleSuccess from '../shared/handle-success';
import type { ISubmitToHubSpot, IFormattedDataHB } from '../types';

// Formats field data to match HubSpot's expected format
const transformFormData = (data: any) => {
  const fields = Object.keys(data).map(key => ({
    name: key,
    value: data[key] !== undefined ? data[key] : '',
  }));
  return fields;
};

export const submitToHubSpot = async ({ formData, context, settings, setErrors, setSuccess, resetRecaptcha, errorText, setFieldError }: ISubmitToHubSpot ) => {
  const fieldsData = transformFormData(formData);
  const timestamp = new Date().getTime();
  const hubSpotData: IFormattedDataHB = { submittedAt: timestamp, fields: fieldsData, context: context };
  const formattedData = { formattedData: hubSpotData, reCaptchaToken: formData['g-recaptcha-response'] };
  
  try {
    const submissionResponse = await fetch('/_gatsby/process/demo-request', {
      method: 'POST',
      body: JSON.stringify(formattedData),
      headers: {
        'content-type': 'application/json',
      },
    });

    const submissionData = await submissionResponse.json();

    if (submissionData.success) {
      resetRecaptcha();
      setSuccess(true);
      handleSuccess(submissionData, 'demo');

      if (window.qualified) {
        window?.qualified?.(
          'saveFormData',
          formData,
        );
        window?.qualified?.('emitFormFill', 'custom');
      }

      gtmFormEvent(formData, 'requestDemo', 'complete').then(() => {
        if (windowIsDefined()) {
          setTimeout(() => {
            if (settings?.redirectUrl) {
              window.location.assign(settings.redirectUrl);
            }
          }, 500);
        }
      });

      if (!settings?.redirectUrl) {
        setErrors([]);
        setSuccess(true);
      }

      return submissionData;
    }

    handleErrors(
      submissionData?.errors || [], 
      setErrors, 
      (field, value) => setFieldError(field, value || ''), 
      formData, 
      'demo',
    );
    resetRecaptcha();

    return false;
  } catch (error) {
    const knownError = error as { code?: string; message?: string; name?: string; stack?: string; status?: string; };
    window?.heap?.track?.('Form Submission Error', {
      code: knownError?.code ?? '',
      emailAddress: formData.email ?? '',
      formName: 'demo',
      host: process.env.GATSBY_HOST ?? '',
      message: knownError?.message ?? '',
      name: knownError?.name ?? '',
      rawJson: JSON.stringify(error) ?? '',
      stack: knownError?.stack ?? '',
      statusCode: knownError?.status ?? '',
    });
    setErrors([errorText.generic]);
    resetRecaptcha();

    return false;
  }
};



